import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Configuration, ConfigurationParameters } from './lib';

export function withBackendApiConfiguration(
  configurationParameters: ConfigurationParameters = {}
): Configuration {
  return new Configuration({
    // any default parameters
    basePath: 'http://localhost:5013/library',
    // overrides
    ...configurationParameters,
  });
}

export function provideApi(
  withConfiguration: Configuration = withBackendApiConfiguration()
): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: Configuration, useValue: withConfiguration }]);
}
